const NotPermission = () => {
  return (
    <section className="flex flex-col items-center justify-center w-full gap-4 px-8 p-6">
      <div className="flex flex-col gap-2 items-center mt-10">
        <p className="text-center">ຂໍອະໄພທ່ານບໍ່ມີສິດເຂົ້າເຖິງໜ້ານີ້.</p>
        <p className="text-center">
          ກະລຸນາຕິດຕໍ່ຜູ້ດູແລລະບົບເພື່ອອະນຸມັດການເຂົ້າເຖິງ.
        </p>
      </div>

      <img src={"/svg/not-support-mobile.svg"} className="w-48 h-48" alt="" />
    </section>
  );
};

export default NotPermission;
